import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

import { fg } from '@confluence/feature-gating';

import { useEmbeddedEditPageFeatures } from '../edit-page/useEmbeddedEditPageFeatures';
import { useEmbeddedViewPageFeatures } from '../view-page/useEmbeddedViewPageFeatures';

export const useEmbeddedComments = () => {
	const isEmbeddedConfluence = isEmbeddedConfluence_DO_NOT_USE();

	const {
		hasComments: hasPageComments,
		hasInlineCommentsAndHighlightActions: hasViewInlineComments,
	} = useEmbeddedViewPageFeatures();
	const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } =
		useEmbeddedEditPageFeatures();

	if (!isEmbeddedConfluence) {
		return true;
	}

	const allowPageCommentsInEmbeddedMode = fg('confluence-mr2-native-allowed-features')
		? hasPageComments
		: true;
	const allowInlineCommentsInEmbeddedMode = fg('confluence-mr2-native-allowed-features')
		? hasViewInlineComments || hasEditInlineComments
		: true;

	return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
